import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './auth'
import { UndoProvider } from './undo'
import { ActivityProvider } from './activity'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Listings reflect a live filesystem that other tools also write to, so
      // refetching on focus is the right default here.
      staleTime: 5_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ActivityProvider>
            <UndoProvider>
              <App />
            </UndoProvider>
          </ActivityProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
